document.addEventListener('DOMContentLoaded', function () {
  // Variables
  const sections = document.getElementsByClassName('content-map')

  // Initializing Items
  for (let i = 0; i < sections.length; i++) {
    // Variables
    const section = sections[i]
    const mapWrapper = section.querySelector('.content-map__wrapper')

    // function to pan with offset
    google.maps.Map.prototype.panToWithOffset = function (latlng, offsetX, offsetY) {
      const map = this
      const ov = new google.maps.OverlayView()
      ov.onAdd = function () {
        const proj = this.getProjection()
        const aPoint = proj.fromLatLngToContainerPixel(latlng)
        aPoint.x = aPoint.x + offsetX
        aPoint.y = aPoint.y + offsetY
        map.panTo(proj.fromContainerPixelToLatLng(aPoint))
      }
      ov.draw = function () {}
      ov.setMap(this)
    }

    async function initMap (mapWrapper, location, infowindowHeader, infowindowContent) {
      // Request needed libraries.
      // @ts-ignore
      // eslint-disable-next-line no-unused-vars, no-undef
      const { Map } = await google.maps.importLibrary('maps')
      // eslint-disable-next-line no-unused-vars, no-undef
      const { AdvancedMarkerElement } = await google.maps.importLibrary('marker')
  
      // Setting up the Map
      // eslint-disable-next-line no-undef
      const map = new google.maps.Map(mapWrapper, {
        zoom: 6,
        center: location,
        panControl: false,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        overviewMapControl: false,
        rotateControl: false,
        mapId: '685c7c7095cbf3b4',
        disableDefaultUI: true,
        clickableIcons: false
      })

      if (window.innerWidth < 640) {
        map.panToWithOffset(location, ((mapWrapper.offsetWidth / 6) * -1), 0)
      }
  
      // Map Marker Functions
      const mapMarker = {
        url: '../../wp-content/themes/rlx/assets/img/map-marker.svg',
        scaledSize: new google.maps.Size(38, 38),
        anchor: new google.maps.Point(19, 19)
      }
  
      const marker = new google.maps.Marker({
        position: location,
        map,
        icon: mapMarker
      })

      if((infowindowHeader != '' || infowindowHeader) != null && (infowindowContent != '' && infowindowContent != null)) {
        const contentString =
          '<div class="content-map__iw-content-wrapper">' +
          '<h1 class="content-map__iw-header">' + infowindowHeader + '</h1>' +
          '<div class="content-map__iw-content">' +
          '<p>' + infowindowContent + '</p>' +
          '</div></div>'

        const infowindow = new google.maps.InfoWindow({
          content: contentString,
          ariaLabel: infowindowHeader,
        })

        marker.addListener("click", () => {
          infowindow.open({
            anchor: marker,
            map
          })
        })

        infowindow.open({anchor: marker,map})
      }
    }

    if (mapWrapper) {
      const mapJson = section.querySelector('.content-map__mapData')
      const parsedData = JSON.parse(mapJson.innerHTML)
      const propLat = parsedData.lat
      const propLng = parsedData.lng
      const propLocation = { lat: Number(propLat), lng: Number(propLng) }
      const infowindowHeader = parsedData.infoWindowHeader
      const infowindowContent = parsedData.infoWindowContent

      initMap(mapWrapper, propLocation, infowindowHeader, infowindowContent)
    }
  }
})
